<div class="flex flex-col flex-grow md:mx-10">
  <div *ngIf="data | async as details" class="mx-5 flex flex-col lg:flex-grow lg:flex-row">
    <div class="lg:pr-16 lg:w-5/12 mt-5 lg:mt-10">
      <div class="hidden lg:inline-block mb-8">
        <ng-container *ngTemplateOutlet="returnBtn"></ng-container>
      </div>

      <div>
        <h1 class="font-bold text-gray-900 text-lg md:text-2xl">
          Przelew tradycyjny
        </h1>

        <p class="mt-3 lg:mt-6 leading-tighter md:text-sm">
          Wykonaj przelew na&nbsp;&nbsp;dane wyświetlone w&nbsp;panelu. Możesz użyć do&nbsp;tego bankowości
          elektronicznej swojego banku lub wykonać tradycyjny przekaz pocztowy.
        </p>
      </div>
    </div>

    <div class="flex flex-col lg:flex-grow lg:bg-gray-300 lg:px-8 xl:px-12">
      <div class="mt-5 lg:mb-8 xl:mb-12 lg:mt-10 rounded-lg border border-gray-200 light-shadow bg-white">
        <h2 class="px-6 py-4 lg:py-5 text-lg font-bold border-b border-gray-200">Dane do przelewu:</h2>

        <div class="flex flex-col px-6 py-4 lg:py-5 border-b border-gray-200 space-y-3 sm:space-y-4 md:space-y-5">
          <ng-container *ngFor="let item of details.transferDetails">
            <ng-container *ngTemplateOutlet="itemTemplate; context: item"></ng-container>
          </ng-container>
        </div>

        <div
          *ngIf="details.bankDetailsVisible; else bankDetailsToggle"
          class="flex flex-col px-6 py-4 lg:py-5 border-b border-gray-200 space-y-3 sm:space-y-4 md:space-y-5"
          [ngClass]="{ 'cursor-pointer': !details.bankDetailsVisible }"
        >
          <ng-container *ngFor="let item of details.bankDetails">
            <ng-container *ngTemplateOutlet="itemTemplate; context: item"></ng-container>
          </ng-container>
        </div>

        <ng-template #bankDetailsToggle>
          <div
            class="px-6 py-5 cursor-pointer text-gray-800 text-xs hover:bg-gray-100"
            mat-ripple
            (click)="details.bankDetailsVisible = true"
          >
            Wyświetl informacje o banku odbiorcy
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <div class="flex flex-col lg:hidden mx-5 mt-3 mb-5">
    <ng-container *ngTemplateOutlet="returnBtn"></ng-container>
  </div>
</div>

<ng-template #itemTemplate let-label="label" let-value="value" let-copyValue="copyValue">
  <div class="flex flex-row gap-2 items-center">
    <div class="flex flex-col flex-grow md:flex-row">
      <span class="text-gray-700 sm:w-40 lg:w-48 flex-shrink-0">{{ label }}</span>
      <span>{{ value }}</span>
    </div>
    <button mat-ripple class="copy-btn" (click)="copy(copyValue || value)">
      <mat-icon class="icon-16 text-gray-700" matTooltip="Kopiuj">content_copy</mat-icon>
    </button>
  </div>
</ng-template>

<ng-template #returnBtn>
  <button routerLink="../" class="flex-grow rounded-lg border border-gray-200 hover:bg-gray-100" mat-ripple>
    <span class="flex flex-row items-center text-gray-600 py-1">
      <mat-icon>chevron_left</mat-icon>
      <span class="flex-grow text-sm pl-3 pr-6">Wróć do wyboru metody płatności</span>
    </span>
  </button>
</ng-template>
